import { newId } from './ulid.js';
import type { Memo, MemoSource } from './types.js';

interface CreateMemoInput {
  userId: string;
  content: string;
  source: MemoSource;
  /** Inject for tests; defaults to system clock. */
  now?: () => Date;
}

export function createMemo(input: CreateMemoInput): Memo {
  const now = (input.now ?? (() => new Date()))();
  const date = `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
  const timestamp = `${pad2(now.getHours())}:${pad2(now.getMinutes())}`;
  const iso = now.toISOString();
  return {
    id: newId(),
    userId: input.userId,
    date,
    timestamp,
    content: input.content,
    source: input.source,
    metadata: null,
    createdAt: iso,
    updatedAt: iso,
    deletedAt: null,
  };
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}
